import { render, staticRenderFns } from "./main_container.html?vue&type=template&id=4bf6975d&external"
import script from "./main_container.vue?vue&type=script&lang=js"
export * from "./main_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports